export const buttonsTemplate = {
    addButton: {
        text: 'common.add',
        action: null,
        isDisabled: () => false,
        class: 'btn-add',
        icon: 'icon-plus',
        order: 10,
    },
    cancelButton: {
        text: 'common.cancel',
        action: null,
        isDisabled: () => false,
        class: 'btn-undo',
        icon: 'icon-close',
        order: 20,
    },
    saveButton: {
        text: 'common.save',
        action: null,
        isDisabled: () => false,
        class: 'btn-save',
        icon: 'icon-save',
        order: 30,
    },
    undoButton: {
        text: 'common.undo',
        action: null,
        isDisabled: () => false,
        class: 'btn-undo',
        icon: 'icon-arrow-left',
        order: 40,
    },
    showButton: {
        text: 'reports.show',
        action: null,
        isDisabled: () => false,
        class: 'btn-add',
        icon: '',
        order: 50,
    },
    exportButtonPdf: {
        text: 'reports.exportPDF',
        action: null,
        isDisabled: () => false,
        class: 'btn-save',
        icon: 'icon-pdf',
        order: 60,
    },
    exportButtonCsv: {
        text: 'reports.exportCSV',
        action: null,
        isDisabled: () => false,
        class: 'btn-save',
        icon: 'icon-csv',
        order: 70,
    },
    editButton: {
        text: 'common.edit',
        action: null,
        isDisabled: () => false,
        class: 'btn-add',
        icon: 'icon-edit-16',
        order: 80,
    },
    cancelNCICallsButton: {
        text: 'checkIn.notCheckedInTab.cancelCallsButton',
        action: null,
        isDisabled: () => false,
        class: 'btn-add',
        icon: 'icon-cancel-calls',
        order: 90,
    },
    disableButton: {
        text: 'common.disable',
        action: null,
        isDisabled: () => false,
        class: 'btn-undo',
        icon: 'icon-cross-thin-1',
        order: 100,
    },
};
